// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".linkContainer--gfVK8G-a {\n  color: var(--antd-link-color);\n  padding: 5px 10px;\n  min-height: var(--editor-brick-base-height);\n  white-space: normal;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n  .linkContainer--gfVK8G-a.empty--2-zOaia5 {\n    border-radius: var(--editor-brick-border-radius);\n    background: var(--editor-brick-skeleton-bg-light);\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linkContainer": "linkContainer--gfVK8G-a",
	"empty": "empty--2-zOaia5"
};
export default ___CSS_LOADER_EXPORT___;
